const newsEventsBlock = document.querySelector('.block-news-events');

if (newsEventsBlock) {
	const tabButtons = newsEventsBlock.querySelectorAll(
		'.block-news-events__tab-button'
	);
	const tabContent = newsEventsBlock.querySelectorAll(
		'.block-news-events__tab-content'
	);

	tabButtons.forEach((button) => {
		button.addEventListener('click', (e) => {
			const index = button.getAttribute('data-index');
			const tab = e.target;

			tabButtons.forEach((t) => t.setAttribute('aria-selected', 'false'));
			tab.setAttribute('aria-selected', 'true');

			// Hide all tab contents first
			tabContent.forEach((content) => {
				content.setAttribute('aria-hidden', 'true');
			});

			// Show the one matching the clicked tab
			const activeContent = newsEventsBlock.querySelector(
				`.block-news-events__tab-content[data-index="${index}"]`
			);

			if (activeContent) {
				activeContent.setAttribute('aria-hidden', 'false');
			}
		});
	});
}
